import { FormValidator, ValidationResult } from '../formField/types/form-validator';
import { IpValidator } from './ip.validator';
import { HostnameValidator } from './hostname.validator';
import { HydraUrlValidator } from './hydra-url.validator';

// one to one validation with vtypeProxyServer on Ext
export const ProxyServerValidator: (errorMessage: string) => FormValidator = (errorMessage: string) => {
  return async (value: string): Promise<ValidationResult> => {
    if (!value) {
      return { valid: true };
    }

    const address = value;

    if (address.startsWith('http://') || address.startsWith('https://')) {
      try {
        if (address === encodeURI(decodeURI(address))) {
          if ((await HydraUrlValidator('')(address)).valid) {
            return { valid: true };
          }

          const url = new URL(address);
          if (url.hostname.indexOf('.') === -1) {
            url.hostname += '.com';
          }

          if ((await HydraUrlValidator('')(url.toString())).valid) {
            return { valid: true };
          }
        }
      } catch (e) {}
    }

    if ((await IpValidator('', true, false)(value)).valid) {
      return { valid: true };
    }

    if ((await HostnameValidator('', false)(value)).valid) {
      return { valid: true };
    }

    return { valid: false, error: errorMessage };
  };
};
